export class Logger {
    public static Log(message?: any, ...optionalParams: any[]): void {
        // this is the one place we'll allow a call to console.log
        // until we move to a proper logging framework.
        //
        // tslint:disable-next-line:no-console
        console.log(message, optionalParams);
    }

    public static Error(message?: any, ...optionalParams: any[]): void {
        // tslint:disable-next-line:no-console
        if (!console.error) {
            return;
        }
        // tslint:disable-next-line:no-console
        console.error(message, optionalParams);
    }
}
